import axios from "axios";

export default async function fetchCommitteeMinutes(
  legislatureOrdinal,
  committeeType,
  committeeTypeCode,
  committeeCode,
  chamber,
  meetingDateTime
) {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_LAWS_BACKEND_HOST}/docs/v1/documents/getMeetingMinutes`,
      {
        params: {
          legislatureOrdinal,
          committeeType,
          committeeTypeCode,
          committeeCode,
          chamber,
          meetingDateTime
        },
      }
    );
    
    if (!Array.isArray(response.data) || response.data.length === 0) {
      return [];
    }

    // Return documents with placeholder for fileName that will be fetched on demand
    return response.data.map(doc => ({
      ...doc,
      fileName: `document-${doc.id}` // placeholder that can be used to trigger the actual fetch
    }));

  } catch (error) {
    if (error.response?.status !== 404) {
      console.error("Error fetching committee minutes:", error);
    }
    return [];
  }
}
